<template>
  <footer class="mt-auto pt-12 bg-main-color border-t border-solid border-[#DEDEDE] no-print">
    <div class="container max-md:px-3.75">
      <div class="flex pb-12 max-lg:flex-col-reverse">
        <div class="flex flex-col w-1/3 max-lg:w-full max-lg:mt-10">
          <img class="w-[140px] h-auto mb-5" src="../assets/images/logo.png" alt="logo" />
          <div class="flex flex-col gap-4">
            <div class="flex gap-4 flex-wrap">
              <a
                href="https://play.google.com/store/apps/details?id=com.ashgabat.giper&pli=1"
                target="_blank"
              >
                <img
                  class="w-28 h-auto"
                  src="../assets/images/googleplay.png"
                  alt="googleplay_icon"
                />
              </a>

              <a
                href="https://apps.apple.com/ru/developer/ykjam-aragatnashyk-economic-society/id1451841593"
                target="_blank"
              >
                <img class="w-28 h-auto" src="../assets/images/appstore.png" alt="appstore_icon" />
              </a>

              <a
                :href="apkLink"
                download
                class="bg-black text-white py-1 px-2 rounded flex items-center gap-1"
                target="_blank"
              >
                <IconDownload></IconDownload>
                {{ $t('page.install_app') }}
              </a>

              <a
                :href="sellerApkLink"
                download
                class="bg-black text-white py-1 px-2 rounded flex items-center gap-1"
                target="_blank"
              >
                <IconDownload></IconDownload>
                {{ $t('page.install_app_business') }}
              </a>
            </div>
          </div>
        </div>

        <div
          class="flex w-2/3 justify-between max-lg:w-full max-lg:flex-wrap max-lg:gap-16 max-lg:justify-normal"
        >
          <div class="flex flex-col">
            <div class="flex flex-col gap-4">
              <router-link :to="{ name: 'about' }" class="font-medium text-white text-lg">
                {{ $t('nav.about') }}
              </router-link>

              <router-link :to="{ name: 'faq' }" class="font-medium text-white text-lg">
                {{ $t('nav.faq') }}
              </router-link>

              <router-link
                :to="{ name: 'deleteAccount' }"
                class="font-medium text-white text-lg"
              >
                {{ $t('nav.deleteAccount') }}
              </router-link>
            </div>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col gap-4">
              <router-link
                :to="{ name: 'aboutAdvertisement' }"
                class="font-medium text-white text-lg"
              >
                {{ $t('nav.aboutAdvertisement') }}
              </router-link>

              <router-link :to="{ name: 'policy' }" class="font-medium text-white text-lg">
                {{ $t('nav.userAgreement') }}
              </router-link>

              <router-link :to="{ name: 'comment' }" class="font-medium text-white text-lg">
                {{ $t('nav.commentRules') }}
              </router-link>
            </div>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col gap-4">
              <router-link :to="{ name: 'contact' }" class="font-medium text-white text-lg">
                {{ $t('nav.contact') }}
              </router-link>

              <router-link :to="{ name: 'privacy' }" class="font-medium text-white text-lg">
                {{ $t('nav.privacy') }}
              </router-link>

              <router-link
                :to="{ name: 'clientChat' }"
                class="relative w-max font-medium text-white text-lg"
                @click="handleChatClick"
              >
                {{ $t('page.chatAdmin') }}
                <span
                  v-if="showUnreadAdminIndicator"
                  class="absolute -right-3 -top-1 h-3 w-3 rounded-full bg-[#00FF47]"
                ></span>
              </router-link>
            </div>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col gap-4">
              <!-- empty -->
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-between py-4 border-t border-solid border-[#DEDEDE] max-md:flex-col max-md:mb-20 max-md:pb-22"
      >
        <a class="opacity-0" href="https://github.com/Marcus-Lorry">Marcus Lorry</a>

        <p class="text-sm text-[#989898]">
          © {{ new Date().getFullYear() }} tpl.com.tm {{ $t('page.rights') }}.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import api from '@/api';
import IconDownload from '@icons/IconDownload.vue';

export default {
  name: 'TheFooter',
  components: {
    IconDownload,
  },
  data() {
    return {
      unreadAdminMessagesCount: 0,
      unreadPolling: null,
    };
  },
  computed: {
    apkLink() {
      return this.$store?.setting?.apk;
    },
    sellerApkLink() {
      return this.$store?.setting?.seller_apk;
    },
    showUnreadAdminIndicator() {
      return this.unreadAdminMessagesCount > 0;
    },
  },
  methods: {
    async fetchUnreadAdminMessagesCount() {
      if (!localStorage.getItem('token')) {
        this.unreadAdminMessagesCount = 0;
        return;
      }

      try {
        const response = await api.get('message_to_admin/', {
          params: { unread_count: 1 },
          skipToast: true,
        });

        this.unreadAdminMessagesCount = Number(response?.data?.unread_count || 0);
      } catch (e) {
        this.unreadAdminMessagesCount = 0;
        console.log(e);
      }
    },
    startUnreadPolling() {
      this.stopUnreadPolling();
      this.unreadPolling = setInterval(() => {
        this.fetchUnreadAdminMessagesCount();
      }, 15000);
    },
    stopUnreadPolling() {
      if (this.unreadPolling) {
        clearInterval(this.unreadPolling);
        this.unreadPolling = null;
      }
    },
    handleUnreadUpdated(event) {
      const count = Number(event?.detail?.count ?? 0);
      this.unreadAdminMessagesCount = Number.isFinite(count) ? count : 0;
    },
    handleChatClick() {
      this.unreadAdminMessagesCount = 0;
    },
  },
  async mounted() {
    window.addEventListener('admin-chat-unread-updated', this.handleUnreadUpdated);
    await this.fetchUnreadAdminMessagesCount();
    this.startUnreadPolling();
  },
  beforeUnmount() {
    window.removeEventListener('admin-chat-unread-updated', this.handleUnreadUpdated);
    this.stopUnreadPolling();
  },
};
</script>
